import { InputAdornment, styled, Typography } from "@mui/material";
import { FastField as Field } from "formik";
import { useFormikContext } from "formik";
import { TextField } from "formik-mui";
import { PercentageRow } from "src/components/fleet/PercentageRow";
import type { FleetPercentageEuro } from "src/types";
import { clampIntegerPercentFromInput } from "src/utils/fleet-percentage.utils";

interface Props {
  emission: FleetPercentageEuro;
  categoryIndex: number;
  fuelIndex: number;
  euroIndex: number;
  readOnly: boolean;
}

export function PercentageEmissionRow(props: Props) {
  const { emission, categoryIndex, fuelIndex, euroIndex, readOnly } = props;
  const fieldName = `categories.${categoryIndex}.fuels.${fuelIndex}.euros.${euroIndex}.euroPercentage`;
  const { setFieldValue } = useFormikContext();

  function handleIntegerInputKeyDown(event: React.KeyboardEvent<HTMLInputElement>) {
    if ([".", ",", "e", "E", "+", "-"].includes(event.key)) {
      event.preventDefault();
    }
  }

  return (
    <Styles>
      <span />
      <Typography>{emission.euroTranslation}</Typography>
      <Field
        name={fieldName}
        component={TextField}
        size="small"
        disabled={readOnly}
        type="number"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setFieldValue(fieldName, clampIntegerPercentFromInput(e.target.value));
        }}
        onKeyDown={handleIntegerInputKeyDown}
        InputProps={{
          endAdornment: <InputAdornment position="end">%</InputAdornment>,
          inputProps: { min: 0, max: 100, step: 1 },
        }}
      />
    </Styles>
  );
}

const Styles = styled(PercentageRow)`
  padding-left: calc(108px);
`;
